// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__cLHH9","header":"Messages_header__2tG-h"};